module.exports = __webpack_public_path__ + "static/media/icon-pool-pump.4aef8acc.svg";